// Messages for portal/QuoteRequestDetail (auto-merged by lib/i18n.ts).
export const en = {
  'portal.quote_request.head': 'Quote request',
  'portal.quote_request.back': 'Quotes',
  'portal.quote_request.submitted': 'Requested {date}',
  'portal.quote_request.state.requested': 'Requested',
  'portal.quote_request.state.in_progress': 'Being priced',
  'portal.quote_request.state.quoted': 'Quoted',
  'portal.quote_request.state.closed': 'Closed',
  'portal.quote_request.view_quote': 'Your quote {ref} is ready — view it',
  'portal.quote_request.hint.requested':
    "We've received your request and our team will price it shortly.",
  'portal.quote_request.hint.in_progress':
    "Our team is preparing your quote — you'll be notified when it's ready.",
  'portal.quote_request.hint.quoted': 'Your quote is ready.',
  'portal.quote_request.hint.closed': 'This request is closed. Submit a new one any time.',
  'portal.quote_request.section.shipment': 'Shipment',
  'portal.quote_request.section.cargo': 'Cargo',
  'portal.quote_request.section.details': 'Notes',
  'portal.quote_request.field.mode': 'Mode',
  'portal.quote_request.field.load_type': 'Load type',
  'portal.quote_request.field.incoterm': 'Incoterm',
  'portal.quote_request.field.origin': 'Origin',
  'portal.quote_request.field.destination': 'Destination',
  'portal.quote_request.field.cargo_ready': 'Cargo ready',
  'portal.quote_request.field.commodity': 'Commodity',
  'portal.quote_request.field.weight': 'Weight',
  'portal.quote_request.field.volume': 'Volume',
  'portal.quote_request.field.reference': 'Reference',
}

export const zhTW = {
  'portal.quote_request.head': '報價申請',
  'portal.quote_request.back': '報價',
  'portal.quote_request.submitted': '申請於 {date}',
  'portal.quote_request.state.requested': '已申請',
  'portal.quote_request.state.in_progress': '報價中',
  'portal.quote_request.state.quoted': '已報價',
  'portal.quote_request.state.closed': '已結案',
  'portal.quote_request.view_quote': '您的報價 {ref} 已就緒 — 立即查看',
  'portal.quote_request.hint.requested': '我們已收到您的申請，團隊將盡快為您報價。',
  'portal.quote_request.hint.in_progress': '我們的團隊正在準備您的報價，完成後將通知您。',
  'portal.quote_request.hint.quoted': '您的報價已就緒。',
  'portal.quote_request.hint.closed': '此申請已結案。您可隨時提交新的申請。',
  'portal.quote_request.section.shipment': '貨件',
  'portal.quote_request.section.cargo': '貨物',
  'portal.quote_request.section.details': '備註',
  'portal.quote_request.field.mode': '運輸方式',
  'portal.quote_request.field.load_type': '裝載類型',
  'portal.quote_request.field.incoterm': '貿易條件',
  'portal.quote_request.field.origin': '起運地',
  'portal.quote_request.field.destination': '目的地',
  'portal.quote_request.field.cargo_ready': '備貨日期',
  'portal.quote_request.field.commodity': '品名',
  'portal.quote_request.field.weight': '重量',
  'portal.quote_request.field.volume': '體積',
  'portal.quote_request.field.reference': '參考編號',
}
